import { useEffect, useState, type ReactNode } from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { createQueryClient, onSessionEnded } from "@/api";
import { AuthProvider } from "@/components/auth";
import { ThemeProvider } from "@/components/theme";
import { ToastWrapper } from "@/components/toast";

/**
 * Провайдеры вне роутера: тема, React Query, сессия вкладки (`AuthProvider` — первый `isauthorized`), тосты.
 * `NuqsAdapter` использует хуки React Router, поэтому он внутри маршрутов (`RootLayout`).
 */
export function Providers({ children }: { children: ReactNode }) {
    // Один QueryClient на вкладку.
    const [queryClient] = useState(createQueryClient);

    // Сессия завершена (повторный 401, выход) — данные прежнего пользователя не должны остаться в кэше.
    useEffect(() => onSessionEnded(() => queryClient.clear()), [queryClient]);

    return (
        <ThemeProvider>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>{children}</AuthProvider>
                {import.meta.env.DEV && <ReactQueryDevtools buttonPosition="bottom-left" />}
            </QueryClientProvider>
            <ToastWrapper />
        </ThemeProvider>
    );
}
